import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { StaticImage } from "gatsby-plugin-image";

// Import our SASS based styles
import "../scss/all.scss";

import HeroHeadings from "../components/HeroHeadings";
import SignUpFormikWrapper from "../components/SignUpForm";
import Modal from "../components/Modal";
import SiteOverlay from "../components/SiteOverlay";
import Decorations from "../components/Decorations";

const IndexPage = () => {
  const [modal, toggleModal] = useState(null);
  const [modalContent, setModalContent] = useState(null);
  const [scroll, toggleScroll] = useState(`hidden`);
  const [revealContent, toggleRevealContent] = useState(false);

  const slogan =
    "The Wild Honey Pie Presents Full bloom, a collaboration with Strainge Beast Hard Kombucha";

  useEffect(() => {
    if (modal) {
      // if press Esc, close modal
      document.addEventListener(
        "keydown",
        (e) => closeModalByKeyPress(e, modal, toggleModal),
        false
      );
    } else {
      document.removeEventListener(
        "keydown",
        (e) => closeModalByKeyPress(e, modal, toggleModal),
        false
      );
    }

    return {
      if(modal) {
        document.removeEventListener(
          "keydown",
          (e) => closeModalByKeyPress(e, modal, toggleModal),
          false
        );
      },
    };
  }, [modal]);

  return (
    <>
      <Helmet>
        <style type="text/css">{`body { overflow: ${scroll}; }`}</style>
      </Helmet>
      <main className={`site-wrapper ${revealContent ? "reveal" : ""}`}>
        <title>
          The Wild Honey Pie Presents Full Bloom | A collaboration with Strainge
          Beast Hard Kombucha
        </title>
        <SiteOverlay
          toggleScroll={toggleScroll}
          toggleRevealContent={toggleRevealContent}
        />
        <div className="hero">
          <div className="hero__bg hero__bg--mobile">
            <StaticImage
              src="../images/backgrounds/bgMobile.jpg"
              alt={slogan}
              placeholder="none"
            />
          </div>
          <div className="hero__bg hero__bg--desktop">
            <StaticImage
              src="../images/backgrounds/bgDesktop.png"
              alt={slogan}
              placeholder="none"
            />
          </div>
          <HeroHeadings
            toggleModal={toggleModal}
            setModalContent={setModalContent}
            toggleScroll={toggleScroll}
          />
          <SignUpFormikWrapper />
          <Decorations />
        </div>
        <Modal
          modal={modal}
          toggleModal={toggleModal}
          modalContent={modalContent}
          toggleScroll={toggleScroll}
        />
      </main>
    </>
  );
};

const closeModalByKeyPress = (event, modal, toggleModal) => {
  // Close by 'ESC' key
  if (event.keyCode === 27) {
    toggleModal(!modal);
  }
};

export default IndexPage;
